var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTomChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 425 233",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "tom-charts",
    x: 0,
    y: 0.063,
    width: 424.42,
    height: 232.239,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M212.21,21.484c1.736,-0 3.471,0.043 5.206,0.13c1.734,0.086 3.464,0.216 5.192,0.389c1.727,0.173 3.45,0.39 5.166,0.649c1.717,0.259 3.426,0.56 5.128,0.905c1.702,0.344 3.394,0.731 5.076,1.16c1.682,0.429 3.353,0.9 5.012,1.412c1.659,0.512 3.304,1.066 4.935,1.66c1.631,0.595 3.247,1.23 4.846,1.905c1.6,0.675 3.182,1.39 4.745,2.144c1.564,0.754 3.108,1.547 4.633,2.378c1.524,0.831 3.026,1.7 4.507,2.606c1.481,0.906 2.938,1.849 4.372,2.828c1.434,0.979 2.843,1.994 4.226,3.043c1.383,1.049 2.739,2.133 4.068,3.25c1.329,1.117 2.629,2.267 3.901,3.449c1.272,1.182 2.513,2.395 3.724,3.639c1.211,1.244 2.39,2.517 3.538,3.82c1.147,1.303 2.262,2.634 3.343,3.993c1.081,1.358 2.127,2.743 3.139,4.154c1.012,1.411 1.988,2.846 2.928,4.305c0.94,1.46 1.844,2.942 2.71,4.447c0.866,1.505 1.694,3.03 2.484,4.576c0.79,1.546 1.541,3.111 2.253,4.694c0.712,1.584 1.384,3.184 2.016,4.801c0.632,1.617 1.223,3.249 1.773,4.896c0.551,1.646 1.06,3.306 1.527,4.978c0.468,1.672 0.893,3.355 1.277,5.048c0.384,1.693 0.725,3.395 1.023,5.105c0.299,1.711 0.555,3.427 0.767,5.15c0.213,1.724 0.383,3.451 0.51,5.182c0.126,1.732 0.21,3.466 0.25,5.201c0.04,1.736 0.036,3.472 -0.01,5.207c-0.047,1.736 -0.137,3.469 -0.27,5.2c-0.133,1.731 -0.31,3.458 -0.529,5.18c-0.22,1.723 -0.482,3.438 -0.787,5.148c-0.305,1.709 -0.653,3.409 -1.043,5.101c-0.39,1.692 -0.822,3.373 -1.296,5.043c-0.474,1.67 -0.989,3.328 -1.546,4.972c-0.556,1.645 -1.154,3.274 -1.792,4.889c-0.638,1.615 -1.316,3.212 -2.034,4.793c-0.718,1.581 -1.475,3.143 -2.271,4.686c-0.796,1.543 -1.63,3.065 -2.502,4.567c-0.871,1.501 -1.78,2.98 -2.726,4.436c-0.946,1.456 -1.927,2.887 -2.945,4.294c-1.017,1.407 -2.069,2.788 -3.155,4.142c-1.086,1.355 -2.205,2.681 -3.358,3.98c-1.152,1.298 -2.336,2.567 -3.552,3.807c-1.216,1.239 -2.462,2.448 -3.738,3.625c-1.276,1.177 -2.581,2.322 -3.914,3.434c-1.333,1.112 -2.694,2.19 -4.081,3.234c-1.387,1.044 -2.799,2.053 -4.237,3.026c-1.437,0.974 -2.898,1.911 -4.383,2.812c-1.484,0.9 -2.99,1.764 -4.517,2.589c-1.528,0.825 -3.075,1.612 -4.641,2.36c-1.567,0.749 -3.152,1.457 -4.754,2.126c-1.602,0.669 -3.22,1.298 -4.853,1.886c-1.634,0.589 -3.281,1.136 -4.941,1.642c-1.661,0.506 -3.334,0.97 -5.018,1.393c-1.684,0.422 -3.377,0.802 -5.08,1.14c-1.703,0.338 -3.414,0.633 -5.131,0.886c-1.718,0.252 -3.441,0.462 -5.169,0.628c-1.728,0.167 -3.46,0.29 -5.194,0.37c-1.734,0.08 -3.47,0.117 -5.206,0.11c-1.736,-0.006 -3.471,-0.056 -5.205,-0.15c-1.733,-0.093 -3.464,-0.229 -5.19,-0.409c-1.727,-0.18 -3.449,-0.402 -5.164,-0.668c-1.716,-0.266 -3.424,-0.574 -5.125,-0.925c-1.7,-0.351 -3.39,-0.744 -5.071,-1.179c-1.681,-0.435 -3.35,-0.912 -5.007,-1.431c-1.657,-0.519 -3.299,-1.079 -4.928,-1.679c-1.629,-0.601 -3.242,-1.242 -4.839,-1.923c-1.597,-0.682 -3.176,-1.402 -4.737,-2.162c-1.561,-0.76 -3.102,-1.559 -4.623,-2.396c-1.521,-0.837 -3.021,-1.712 -4.498,-2.624c-1.477,-0.912 -2.931,-1.86 -4.361,-2.844c-1.43,-0.985 -2.835,-2.005 -4.214,-3.059c-1.379,-1.055 -2.731,-2.143 -4.056,-3.266c-1.325,-1.122 -2.621,-2.276 -3.888,-3.463c-1.267,-1.187 -2.503,-2.405 -3.71,-3.654c-1.206,-1.248 -2.381,-2.526 -3.523,-3.834c-1.143,-1.307 -2.252,-2.642 -3.328,-4.005c-1.075,-1.362 -2.116,-2.751 -3.123,-4.166c-1.006,-1.414 -1.977,-2.853 -2.912,-4.316c-0.934,-1.464 -1.832,-2.949 -2.692,-4.457c-0.861,-1.508 -1.683,-3.037 -2.467,-4.586c-0.784,-1.549 -1.529,-3.116 -2.235,-4.703c-0.706,-1.586 -1.372,-3.189 -1.997,-4.808c-0.626,-1.62 -1.211,-3.254 -1.755,-4.903c-0.544,-1.648 -1.047,-3.31 -1.508,-4.983c-0.462,-1.674 -0.881,-3.359 -1.258,-5.053c-0.377,-1.695 -0.712,-3.398 -1.004,-5.11c-0.292,-1.711 -0.541,-3.429 -0.747,-5.153c-0.206,-1.723 -0.37,-3.451 -0.49,-5.183c-0.12,-1.733 -0.196,-3.466 -0.23,-5.202c-0.033,-1.736 -0.023,-3.472 0.03,-5.207c0.053,-1.736 0.15,-3.469 0.29,-5.199l103.963,8.399l0,-104.302Z",
    style: {
      fill: "#0496ff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.247,117.387c0.674,-8.34 2.327,-16.48 4.959,-24.422c2.633,-7.941 6.17,-15.457 10.612,-22.548l88.392,55.369l-103.963,-8.399Z",
    style: {
      fill: "#05558f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.818,70.417c2.335,-3.728 4.897,-7.295 7.684,-10.7c2.787,-3.405 5.778,-6.62 8.972,-9.646c3.194,-3.027 6.566,-5.839 10.116,-8.439c3.55,-2.599 7.25,-4.965 11.099,-7.096c3.849,-2.131 7.818,-4.011 11.905,-5.64c4.087,-1.629 8.261,-2.994 12.521,-4.095c4.26,-1.101 8.573,-1.929 12.937,-2.484c4.365,-0.555 8.748,-0.833 13.148,-0.833l0.01,104.302l-88.392,-55.369Z",
    style: {
      fill: "#0570bd",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: "303.428px",
    y: "192.266px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "High School"), /*#__PURE__*/React.createElement("text", {
    x: "318.937px",
    y: "207.68px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "7", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "324.126px ",
    y: "207.68px "
  }, "6")), ".3%")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-61.4052,-28.1931)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "154.865px",
    y: "40.236px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "V", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "161.355px ",
    y: "40.236px "
  }, "o")), "cational ", _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: "209.864px ",
    y: "40.236px "
  }, "t")), "ra"), /*#__PURE__*/React.createElement("text", {
    x: "224.017px",
    y: "40.236px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "i"), /*#__PURE__*/React.createElement("text", {
    x: "226.623px",
    y: "40.236px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "n"), /*#__PURE__*/React.createElement("text", {
    x: "233.148px",
    y: "40.236px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "i"), /*#__PURE__*/React.createElement("text", {
    x: "235.753px",
    y: "40.236px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "ng")), /*#__PURE__*/React.createElement("text", {
    x: "127.442px",
    y: "27.446px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "16.", _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: "140.534px ",
    y: "27.446px "
  }, "1")), "%")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-56.7483,-30.7064)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "57.775px",
    y: "109.746px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "Appr", _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: "81.799px ",
    y: "109.746px "
  }, "e")), "nticesh"), /*#__PURE__*/React.createElement("text", {
    x: "125.121px",
    y: "109.746px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "i"), /*#__PURE__*/React.createElement("text", {
    x: "127.727px",
    y: "109.746px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "p DU", _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: "151.607px ",
    y: "109.746px "
  }, "A")), "L")), /*#__PURE__*/React.createElement("text", {
    x: "43.526px",
    y: "94.443px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "7", _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: "48.35px 50.944px ",
    y: "94.443px 94.443px "
  }, ".6")), "%"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomChart);
export default __webpack_public_path__ + "static/media/tom-chart.fe7f62720abfda4f5a237cfd533eaf5c.svg";
export { ForwardRef as ReactComponent };